import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponenteComPaginacao } from 'src/app/helper';
import { ListaPaginada } from 'src/app/models';

@Component({
  selector: 'app-paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.scss']
})
export class PaginacaoComponent<
  T extends ListaPaginada
> extends ComponenteComPaginacao {
  @Input() nomeDaLista: string;
  @Input() itensPorPagina = [5, 10, 15, 30, 60, 80, 100];
  @Input() dados: T;
  @Output() dadosChange = new EventEmitter<T>();
  manipularItensPorPagina() {
    this.dadosChange.emit({ ...this.dados, paginaAtual: 1 });
  }
  constructor() {
    super();
  }
}
